// Copyright (c) 2016 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.spa.claim,
    formValidation: state.claims.spa.formValidation,
    isEditable: state.claims.spa.isEditable,
    isValidClaim: state.claims.spa.isValidClaim,
    ownershipStatus: state.claims.ownershipStatus,
    product: state.claims.spa.product,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    spaTypes: state.claims.spa.spaTypes
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/spa/components/claim-details-section/index.js